import {DragEventsType, DragItemType, GridType} from "../../types";
import React from "react";
import cloneDeep from "lodash.clonedeep";
import {clearColumnsAsync, clearRowsAsync} from "./cleanColumns";
import {validatePosition} from "./validatePositions";
import {findFilledRowOrColumn} from "./findFilledRowOrColumn";
import {createRandomDragItem, getInitialDragData} from "./getInitialDragData";
import {DIMENSION_GRID} from "../../contants";
import {randomBooleanWithProbability, randomInteger} from "../common/random";
import {dataStorage} from "../StorageService";
import {eventEmitter} from "../../EventEmitter";

export const putItemOnGrid = async (
    gridData: GridType,
    dragItem: DragItemType,
    over: string,
    setGridData: (data: GridType) => void,
    typeEvent: DragEventsType,
    setDragItems: React.Dispatch<React.SetStateAction<DragItemType[]>>,
    setScore: React.Dispatch<React.SetStateAction<number>>,
    panelItemSize: number,
    playSoundCombo: () => void,
    itemSize: number,
    playSoundBomb: () => void,
) => {
    let copyGridData = cloneDeep(gridData);
    let clearRowOrCol = false;

    for (let i = 0; i < copyGridData.length; i++) {
        for (let j = 0; j < copyGridData[i].length; j++) {
            const itemOnGrid = copyGridData[i][j].item;

            // убираем подсказку (hint)
            copyGridData[i][j].isHinted = false;

            if (itemOnGrid && itemOnGrid.type === 'GHOST') {
                copyGridData[i][j].item = undefined;
            }

        }
    }


    if (over) {
        const [column, row] = over.split('-').map(index => +index);
        const positions = validatePosition(column, row, copyGridData, dragItem);


        for (let [iCol, iRow] of positions) {
            copyGridData[iCol][iRow].item = {...dragItem, type: "GHOST"};
        }

        if (typeEvent === 'END') {
            for (let [iCol, iRow] of positions) {
                copyGridData[iCol][iRow].item = {...dragItem, type: "VISIBLE"}
            }

            if (positions.length) {
                setScore(prevScore => prevScore + dragItem.items.length);
                setDragItems(prev => {
                    const items = prev.filter(item => item.id !== dragItem.id);
                    items.splice(dragItem.indexToolPanel!, 0, createRandomDragItem(panelItemSize, dragItem.indexToolPanel!))
                    return items;
                });
            }

            const {columns, rows} = findFilledRowOrColumn(copyGridData);

            // чистка столбца при заполнении
            if (columns.length) {
                clearRowOrCol = true;
                clearColumnsAsync(columns, copyGridData, setGridData, playSoundBomb).then((grid) => {
                    if (dataStorage.isBombMode && positions.length) {
                        setTimeout(() => {
                            handleBombMode(grid[0], itemSize, playSoundBomb);
                            // hack чтобы вызывать сейв
                            setScore(prevScore => prevScore - 1);
                            setScore(prevScore => prevScore + 1);
                        }, 300)
                    }
                });
                columns.forEach(() => {
                    setScore(prevScore => prevScore + DIMENSION_GRID);
                })
                playSoundCombo();
            }
            // чистка строки при заполнении
            if (rows.length) {
                clearRowOrCol = true;
                clearRowsAsync(rows, copyGridData, setGridData, playSoundBomb).then((grid) => {
                    if (dataStorage.isBombMode && positions.length) {
                        setTimeout(() => {
                            handleBombMode(grid[0], itemSize, playSoundBomb);
                            // hack чтобы вызывать сейв
                            setScore(prevScore => prevScore - 1);
                            setScore(prevScore => prevScore + 1);
                        }, 300)
                    }
                });
                rows.forEach(() => {
                    setScore(prevScore => prevScore + DIMENSION_GRID);
                })
                playSoundCombo();
            }

            // Асинхронная обработка режима с бомбой
            // setTimeout(() => {
                if (dataStorage.isBombMode && positions.length && !clearRowOrCol) {
                    handleBombMode(copyGridData, itemSize, playSoundBomb);
                    // hack чтобы вызывать сейв
                    setScore(prevScore => prevScore - 1);
                    setScore(prevScore => prevScore + 1);
                }
            // }, 500)
        }

    }

    setGridData(copyGridData);
}

//TODO баг если у бомбы movesLeft 1 и в этот момент игрок ставит фигуру
// и очищает строку или столбец то показывает конец игры, что неверно

// если режим с бомбой и игрок точно поставил фигурку на поле
const handleBombMode = (copyGridData: GridType, itemSize: number, playSoundBomb: { (): void; (): void; }) => {
        for (let i = 0; i < copyGridData.length; i++) {
            for (let j = 0; j < copyGridData[i].length; j++) {
                const itemOnGrid = copyGridData[i][j].item;

                if (itemOnGrid && itemOnGrid.typeOfItem === 'BOMB') {
                    if (itemOnGrid.bombMovesLeft) {
                        itemOnGrid.bombMovesLeft -= 1;
                    }

                    if (!itemOnGrid.bombMovesLeft) {
                        if (itemOnGrid.isDisappearance) {
                            itemOnGrid.isDisappearance = true;
                        }
                        playSoundBomb();
                        eventEmitter.emit('game_over_by_bomb', {});
                    }
                }
            }
        }

        const bombPosition = generateBombRandomPosition(copyGridData, itemSize);
        if (bombPosition) {
            copyGridData[bombPosition[0]][bombPosition[1]].item = getInitialDragData('BOMB', itemSize);
        }

        return copyGridData
}

export function validateMultiplePositions(positions: any[], copyGridData: GridType, dragItem: DragItemType) {
    const results = [];

    for (let i = 0; i < positions.length; i++) {
        const position = validatePosition(positions[i][0], positions[i][1], copyGridData, dragItem);
        if (position.length > 0) {
            results.push(position);
        }
    }

    return results;
}

//делать не больше одной бомбы одновременно на поле
export function generateBombRandomPosition(copyGridData: GridType, size: number) {
    let bombCount = 0;
    for (let i = 0; i < copyGridData.length; i++) {
        for (let j = 0; j < copyGridData[i].length; j++) {
            const itemOnGrid = copyGridData[i][j].item;

            copyGridData[i][j].isHinted = false;

            if (itemOnGrid && itemOnGrid.typeOfItem === 'BOMB') {
                bombCount++;
            }
        }
    }

    // с вероятностью 22.5% ставим бомбу
    if (!randomBooleanWithProbability(0.225) || bombCount >= 1) return null;

    const bombAvailablePositions = validateMultiplePositions(generatePositions(DIMENSION_GRID), copyGridData, getInitialDragData('BOMB', size));

    const [col, row] = bombAvailablePositions[randomInteger(0, bombAvailablePositions.length - 1)][0]

    if (col !== undefined && row !== undefined) {
        return [col, row];
    }

    return null;
}

// Генерируем все позиции для матрицы размером 10x10
export function generatePositions(gridSize: number) {
    const positions = [];
    for (let i = 0; i < gridSize; i++) {
        for (let j = 0; j < gridSize; j++) {
            positions.push([i, j]);
        }
    }
    return positions;
}
